import React, { useEffect, useRef } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'

import { PGET } from 'helpers/api'

function Search({ url, search, getData, searchValue }) {
	const { t } = useTranslation()
	const searchRef = useRef(null);
	useEffect(() => {
		const handleKeyPress = (e) => {
			// Exclude Control key and common shortcuts
			if (e.key === "Control") return;

			// Exclude common shortcuts with Ctrl, Alt, or Meta keys
			if (e.ctrlKey || e.altKey || e.metaKey) return;

			// Exclude function keys (F1, F2, etc.)
			if (e.key.startsWith('F') && e.key.length > 1) return;

			// Exclude system keys
			const systemKeys = ['Tab', 'Escape', 'Enter', 'Shift', 'CapsLock', 'Home', 'End', 'PageUp', 'PageDown', 'Insert', 'Delete', 'PrintScreen', 'ScrollLock', 'Pause'];
			if (systemKeys.includes(e.key)) return;

			// Exclude arrow keys
			if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;

			const active = document.activeElement;
			const isEditable =
				active &&
				(active.tagName === "INPUT" || active.tagName === "TEXTAREA") &&
				!active.disabled &&
				!active.readOnly;

			if (!isEditable) {
				// Agar hech qanday input fokusda bo'lmasa
				searchRef.current.focus();
			}
		};

		document.addEventListener("keydown", handleKeyPress);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
		};
	}, []);
	async function requestToServer(value) {
		var data;
		var symbol = '?'
		url.includes("?") ? symbol = '&' : symbol = '?'

		if (value.length === 0) {
			getData(true)
		}

		if (value.length > 1) {
			data = await PGET(url + symbol + "search=" + value)
			search(data.data, value, data.headers['x-total-count'])
		}
	};

	return (
		<div className="position-relative me-2">
			<i className="uil-search input-search-icon"></i>
			<DebounceInput
				inputRef={searchRef}
				type="text"
				className="form-control"
				placeholder={t('SEARCH') + '...'}
				minLength={1}
				debounceTimeout={1000}
				value={searchValue}
				onChange={(e) => requestToServer(e.target.value)}
				onKeyUp={(e) => {
					if (e.keyCode === 13) {
						requestToServer(e.target.value)
					}
				}}
			/>

		</div>
	)
}

export default Search
